
const pickupInfoGridTabStyles = (theme: Record<string, any>) => ({
  tabRoot: {
    color: theme.TextColor,
    textTransform: 'none',
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    '&$tabSelected': {
      color: theme.HeaderSelectedText
    },
    '&:hover': {
      color: theme.HeaderSelectedText,
      opacity: 1
    },
    minWidth: 140
  },
  tabsIndicator: {
    display: 'none'
  },
  labelContainer: {
    padding: '6px 8px'
  },
  tabSelected: {},
  tabsHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `1px solid ${theme.AppBGColor}`
  }
});

export default pickupInfoGridTabStyles;
